module.exports = __webpack_public_path__ + "img/simplysift-dark.d302cb84.png";